import { is } from '../../is.js';
import { getStyleDeclaration } from './get-style-declaration.js';
import { parentActiveState, parentHoverState, widgetSelector } from './helpers';

export function textWidget(widgetDescription) {
  const { placements = [], styledStates, parent } = widgetDescription;
  const selector = widgetSelector(widgetDescription);

  if (is.widget.voteButton(parent) || is.widget.quizButton(parent)) {
    const rules = [];

    if (!styledStates) {
      return rules;
    }

    const { default: base, hover, click: active } = styledStates;
    const parentSelector = widgetSelector(parent);

    rules.push([selector, [['color', base.color]]]);
    rules.push([selector, [['transition', 'color 250ms ease']]]);

    rules.push([
      parentHoverState(parentSelector, selector),
      [['color', hover.color]],
    ]);

    rules.push([
      parentActiveState(parentSelector, selector),
      [['color', active.color]],
    ]);

    /*
    such text widget, e.g. `simpleText` does not have own placements
    and rely on styles defined via class
     */
    return rules;
  }

  return [
    ...placements.map(getStyleDeclaration.positions(selector)),
    ...placements.map(getStyleDeclaration.size(selector)),
  ];
}
